<script>
export default {
  name: "apprPlan"
}
</script>

<template>

</template>

<style scoped>

</style>